
import Vue from 'vue';
import { isWeiXin } from '@/common/ts/common';
import Header from './components-pc/Header.vue';
import PcPageLoading from './components-pc/PcPageLoading.vue';
import { getBaseInfo } from './api';

export default Vue.extend({
  name: 'ViewHolderPc',
  components: {
    Header,
    PcPageLoading,
  },
  data() {
    return {
      baseInfoLoading: false,
      baseInfo: {} as any,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.onRouteChange();
      },
    },
  },
  async created() {
    document.body.classList.add('dxscycbdspc-page');
    this.baseInfoLoading = true;
    try {
      const ret = await getBaseInfo();
      this.baseInfo = ret.data;
      if (this.baseInfo.activityId) {
        this.$addPv(this.baseInfo.activityId);
      }
    } finally {
      this.baseInfoLoading = false;
    }
  },
  destroyed() {
    document.body.classList.remove('dxscycbdspc-page');
  },
  methods: {
    onRouteChange() {
      const cover =
        'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
      this.$appShareInfo({
        title: '重庆市大学生创意传播作品大赛',
        url: location.href,
        subtitle: '重庆市大学生创意传播作品大赛',
        classId: -1,
        id: -1,
        image: cover,
        type: 3,
      });
      if (isWeiXin()) {
        this.$wxShareInfo({
          title: '重庆市大学生创意传播作品大赛',
          subtitle: '重庆市大学生创意传播作品大赛',
          image: cover,
        });
      }
    },
  },
});
